/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { DataCompletionResponse } from '../models/data-completion-response';
import { getData } from '../fn/data-completion/get-data';
import { GetData$Params } from '../fn/data-completion/get-data';

@Injectable({ providedIn: 'root' })
export class DataCompletionService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getData()` */
  static readonly GetDataPath = '/api/data-completion';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getData()` instead.
   *
   * This method doesn't expect any request body.
   */
  getData$Response(params?: GetData$Params, context?: HttpContext): Observable<StrictHttpResponse<DataCompletionResponse>> {
    return getData(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getData$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getData(params?: GetData$Params, context?: HttpContext): Observable<DataCompletionResponse> {
    return this.getData$Response(params, context).pipe(
      map((r: StrictHttpResponse<DataCompletionResponse>): DataCompletionResponse => r.body)
    );
  }

}
